import Vue from 'vue'
// import LazyLoad from "vanilla-lazyload";

import { removeDuplicateTags, removeByKey  } from './helpers/vue_tools.js';


const app = new Vue({
    delimiters: ['${', '}'],
    data:{
        loaded: false,
        totalPagesLoaded: 1,
        totalPages: null,
        perPage: 200,
        headers: {
            totalEntires: null,
            totalQueryPages: null,
        },
        settings:{
            query:{
                postType: 'alumni-at-work',
                orderby: 'ASC',
            },
            labels:{
                sort_by: 'Upcoming Events',
                filter_by: 'Filter By',
            }
        },
        // filters:{
        //     sort_by:[
        //         {
        //             key: 'date',
        //             label: 'Upcoming Events',
        //         },
        //         {
        //             key: 'title',
        //             label: 'Alphabetical',
        //         }
        //     ],
        //     tags:[],
        // },
        // tags: {
        //     // tmp: [],
        //     list: [],
        //     applied: [],
        // },
        displayed_data: [],
        entries: [],

    },
    mounted: function(){
        const t = this;
        t.$data.url = window.location.href;

        t.queryAPI({});
    },
    methods:{

        queryAPI: function( params ){
            const t = this;

            let fetchURL = '/wp-json/wp/v2/'+t.$data.settings.query.postType+'/';
                fetchURL += '?per_page=100&page=' + t.$data.totalPagesLoaded;
                fetchURL += '&custom_order_by=' + t.$data.settings.query.orderby;

            fetch( fetchURL ).then(function (response) {
                if(response.ok){

                    response.headers.forEach( function(element, index) {
                        if(index==='x-wp-total'){
                            t.$data.headers.totalEntires = parseInt(element);
                        }

                        if(index==='x-wp-totalpages'){
                            t.$data.headers.totalQueryPages = parseInt(element);
                        }
                    });

                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {
                    t.$data.totalPages = t.$data.headers.totalEntires / t.$data.perPage;
                    t.parseData( data );

                    t.$data.loaded = true;

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },
        parseData: function( data ){
            const t = this;
            t.$data.entries = [];

            if(data.length ){
                for(let i = 0, length1 = data.length; i < length1; i++){

                    // Divider Date
                    let date_options = { year: 'numeric', month: 'long' };

                    let formatted_date = new Date( data[i].date ).toLocaleDateString("en-US", date_options);


                    let entryData = {
                        index: i,
                        id: data[i].id,
                        post_date: data[i].date,
                        formatted_date: formatted_date,
                        title: data[i].title.rendered,
                        slug: data[i].slug,
                        url: data[i].link,
                        featured_image: data[i].the_featured_image,
                        excerpt: data[i].excerpt.rendered,
                    };

                    t.$data.entries.push( entryData );
                };

                t.$data.displayed_data = t.$data.entries;
            }
        },
        getSrcSet: function( obj ) {
            console.log( obj );
            let scrset_string = '';

            if(obj.sizes.headshot_large) scrset_string += obj.base_path+obj.sizes.headshot_large.file+' 1x';

            if(obj.sizes.headshot_large_xhidpi) scrset_string += ', ' + obj.base_path+obj.sizes.headshot_large_xhidpi.file+' 2x';

            if(obj.full_path) scrset_string += ', ' + obj.full_path+' 3x';

            return scrset_string;
        },
        fullPath: function( obj ) {
            // console.log( obj );
            return obj.base_path+obj.sizes.headshot_large.file
        },
        loadMore: function( $event ){
            // console.log( 'loadMore', $event );
        }
    }
}).$mount('#alumni-at-work-app')
